/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Pick_CategoryInputs */

const vi_shop_home_link_pick_category = /** @type {(inputs: Shop_Home_Link_Pick_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục bán`)
};

/**

* @param {Shop_Home_Link_Pick_CategoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_pick_category = /** @type {((inputs?: Shop_Home_Link_Pick_CategoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Pick_CategoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_pick_category(inputs)
});